// Fusion's regression watch raises its alerts as GRC alert rows (source "Fusion", no control): the
// previous / new status fields hold the tracked chain's connected exposure when tracking started and
// now. These helpers let the GRC alert UIs word such a row as an exposure rise and link to Fusion.

export const FUSION_ALERT_SOURCE = "Fusion";

export const FUSION_PATH = "/Fusion";

export const isFusionAlert = (alert) => alert?.controlSource === FUSION_ALERT_SOURCE;

/** "Connected exposure rose from $26K to $52K" — the line shown instead of a status change. */
export const fusionAlertSummary = (alert) =>
  `Connected exposure rose from ${alert?.previousStatus || "—"} to ${alert?.newStatus || "—"}`;
